// NotFound.tsx
import { useDarkMode } from "@/hooks/useDarkMode";
import { useI18N } from "common/hooks";
import NoSearchResultsFilter from "@/assets/images/noresultsfilter.svg";
import { Link } from "@tanstack/react-router";

function NotFound() {
  const isDark = useDarkMode();
  const i18n = useI18N();

  return (
    <div className="flex flex-col items-center justify-center flex-1 mt-20">
      <img
        src={NoSearchResultsFilter}
        alt="Page not found"
        className="max-w-[50%]"
      />
      <p className="mt-6 mx-auto text-center desktop-h1-xsmall-extra-bold text-primary-800 dark:text-primary-150">
        {i18n.get("noPageFound")}
      </p>
      <p className="text-center max-w-[80%] md:max-w-[60%] paragraph-medium-regular text-primary-800 dark:text-primary-150">
        {i18n.get("bitLostMessagePage")}
      </p>

      <Link to="/" role="button">
        <button className="mt-4 px-6 py-3 rounded-xl text-white dark:text-primary-800 text-base font-semibold leading-normal bg-primary-800 dark:bg-primary-300">
          <span className="text-center text-white dark:text-primary-800 mobile-h3-small-semi-bold">
            {i18n.get("gotoHomePage")}
          </span>
        </button>
      </Link>
    </div>
  );
}

export default NotFound;
